<template>
  <div>
    <s-info-modifiable
      titre=""
      titre-action="Ajouter"
      :isValid="valid"
      @validateUpdate="envoyerRequetteAjouterDispositif"
      @cancelUpdate="resetTempDispositif"
    >
      <template v-slot:champ>
        <v-form ref="form" v-model="valid">
          <v-container class="pa-0">
            <v-row no-gutters>
              <v-col cols="12">
                <v-text-field v-model="tempDispositif.libelle" label="Libelle" :rules="libelleRules" counter />
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="tempDispositif.dureeMaximum"
                  label="Nombre maximum de jours d'accueils"
                  type="number"
                  :rules="nombreDeJoursRules"
                  suffix="jours"
                  hide-spin-buttons
                />
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </template>
      <template #contentToDisplay>
        <div>
          <span v-if="!dispositifs">Aucun dispositifs</span>
          <v-chip
            class="ma-1"
            label
            large
            outlined
            color="secondary"
            text-color="black"
            v-for="dispositif in dispositifs"
            :key="dispositif.dispositifId"
            close
            @click:close="initiateDeletion(dispositif)"
          >
            {{ dispositif.libelle }}
            <v-chip class="ml-2" label color="secondary">{{ dispositif.dureeMaximum }} jours maximum</v-chip>
          </v-chip>
        </div>
      </template>
    </s-info-modifiable>
    <v-progress-linear v-show="loading" :indeterminate="loading"></v-progress-linear>
    <v-dialog max-width="500" v-model="dialogConfirmSupression">
      <v-card v-if="possibleSupression">
        <v-card-title>Confirmation ?</v-card-title>
        <v-card-subtitle
          >Voulez vous vraiment retirer le dispositif <strong>{{ possibleSupression.libelle }}</strong
          >. Ceci aura pour effet d'empêcher l'accueil de nouveaux usager avec ce dispositif mais n'affectera pas les
          dispositifs existants.</v-card-subtitle
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="info" @click="confirmPossDeletion">Confirmer</v-btn>
          <v-btn color="grey" @click="cancelPossDeletion">Annuler</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="errorOnComptablesFetch">Échec de la récupération de la liste des dispositifs</v-snackbar>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import SInfoModifiable from '../../../components/global/s-info-modifiable.vue'

export default {
  name: 'etablissement-dispositifs',
  components: { SInfoModifiable },
  props: {
    etablissement: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      valid: false,
      dispositifs: undefined,
      possibleSupression: undefined,
      dialogConfirmSupression: false,
      errorOnComptablesFetch: false,
      tempDispositif: undefined,
      libelleRules: [
        (v) => !!v || v.lenght === 0 || 'Information obligatoire',
        (v) => v.length > 2 || 'Trop court (3 caractères minimum)',
      ],
      nombreDeJoursRules: [
        (v) => !!v || 'Information obligatoire',
        (v) => !isNaN(v) || 'Entrez une valeur numérique',
        (v) => v > 0 || 'Entrez une valeur positive',
      ],
    }
  },
  methods: {
    ...mapActions({
      ajouterDispositif: 'etablissement/ajouterDispositif',
      retirerUnDispositif: 'etablissement/retirerUnDispositif',
      getDispositifs: 'etablissement/obtenirListeDispositifsEtablissement',
    }),
    initiateDeletion(utilisateurComptable) {
      this.possibleSupression = utilisateurComptable
      this.dialogConfirmSupression = true
    },
    resetTempDispositif() {
      this.tempDispositif = {
        libelle: undefined,
        dureeMinimum: undefined,
        dureeMaximum: undefined,
      }
      this.$refs.form.reset()
    },
    envoyerRequetteAjouterDispositif() {
      this.$refs.form.validate()
      if (this.valid) {
        this.loading = true
        this.ajouterDispositif({
          etablissementId: this.etablissement.etablissementId,
          dispositif: this.tempDispositif,
        }).then(() => {
          this.dialogConfirmSupression = false
          this.fetchDispositifs()
          this.resetTempDispositif()
          this.loading = false
        })
        this.$refs.form.reset()
      }
    },
    confirmPossDeletion() {
      this.loading = true
      this.retirerUnDispositif({
        _etablissementId: this.etablissement.etablissementId,
        _dispositifId: this.possibleSupression.dispositifId,
      }).then(() => {
        this.loading = true
        this.dialogConfirmSupression = false
        this.fetchDispositifs().then(() => (this.loading = false))
      })
    },
    cancelPossDeletion() {
      this.possibleSupression = undefined
      this.dialogConfirmSupression = false
    },
    async fetchDispositifs() {
      this.loading = true
      this.getDispositifs(this.etablissement.etablissementId).then((value) => {
        if (value.estReussi) {
          this.dispositifs = value.dispositifs.length > 0 ? value.dispositifs : null
          this.loading = false
        } else {
          this.errorOnComptablesFetch = true
          this.loading = false
        }
      })
    },
  },
  created() {
    this.fetchDispositifs()
    this.resetTempDispositif()
  },
}
</script>

<style scoped></style>
